import { CHECK_TYPE, getBaseApi, getData, LOGIN, LOGOUT, postData, REFRESH } from './index';
export const login = (email, password) => postData(`${getBaseApi(LOGIN)}`, { email, password });
export const logout = () => postData(`${getBaseApi(LOGOUT)}`);
export const refresh = () => getData(`${getBaseApi(REFRESH)}`);
export const checkType = () => getData(`${getBaseApi(CHECK_TYPE)}`);
